<template>
  <v-theme-provider :dark="dark">
    <div>
      <base-info-card
        :title="title"
        color="primary"
      >
        <slot />
      </base-info-card>

      <template v-for="({ icon, text, title: t }, i) in business">
        <base-avatar-card
          :key="i"
          :icon="icon"
          :outlined="false"
          :title="!dense ? t : undefined"
          color="transparent"
          horizontal
          space="0"
        >
          <!-- Do not use v-html for user -->
          <!-- provided values -->
          <div v-html="text" />
        </base-avatar-card>

        <v-divider
          v-if="i + 1 !== business.length"
          :key="`divider-${i}`"
          class="my-2"
        />
      </template>
    </div>
  </v-theme-provider>
</template>

<script>
  export default {
    name: 'BaseBusinessContact',
    props: {
      dark: Boolean,
      dense: Boolean,
      title: String,
    },
    data: () => ({
      business: [
        {
          icon: 'mdi-map-marker-outline',
          title: 'Address',
          text: 'Казахстан, 050039, г.Алматы,<br> ул.Ахметова, 51 "Б", 4 этаж, 410 офис. 16п.',
        },
        {
          icon: 'mdi-cellphone',
          title: 'Phone',
          text: '+7 727 385 3862<br>+7 727 385 3867<br>+7 701 533 2111',
        },
        {
          icon: 'mdi-email',
          title: 'Email',
          text: 'p.engi@mail.ru',
        }
      ]
    })
  }
</script>
